

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { StoreSubscriptionPaymentView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminStoreSubscriptions } from "@/lib/query/core/invalidation";
import { queryKeys } from "@/lib/query/core/query-keys";

type ArchiveStoreSubscriptionPaymentInput = {
  storeId: string;
  paymentId: string;
};

export function useArchiveStoreSubscriptionPaymentMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ storeId, paymentId }: ArchiveStoreSubscriptionPaymentInput) =>
      apiJsonClient<StoreSubscriptionPaymentView>(
        endpoints.admin.storeSubscriptionPaymentById(storeId, paymentId),
        { method: "DELETE" },
      ),
    onSuccess: async (_data, variables) => {
      await Promise.all([
        invalidateAdminStoreSubscriptions(queryClient, variables.storeId),
        queryClient.invalidateQueries({
          queryKey: queryKeys.admin.storeSubscriptionPaymentProofUrl(
            variables.storeId,
            variables.paymentId,
          ),
          exact: true,
        }),
      ]);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
